import Vue from 'vue'
import GetTextPlugin from 'vue-gettext'
import translations from './translations/translations.js'
import router from './router/public'
import store from './store/public'
import MainComponent from './components/layout/MainComponent.vue'
import { API_ROOT } from '@/api/config'
import AuthUser from '@/classes/auth/AuthUser'
import Buefy from 'buefy'
import bugsnagClient from '@/utility/bugsnag'
import browserDetect from 'vue-browser-detect-plugin'
import './assets/scss/app.scss'

require('./assets/sass/style.sass')

const bugsnagVue = require('bugsnag-vue')
bugsnagClient.use(bugsnagVue(Vue))

Vue.config.productionTip = false
process['API_ENDPOINT'] = API_ROOT
Vue.use(browserDetect)
Vue.use(GetTextPlugin, {
  availableLanguages: {
    en: 'English',
    sv: 'Svenska'
  },
  defaultLanguage: AuthUser.getLanguage() || 'sv',
  translations: translations,
  silent: true
})
Vue.use(Buefy)

Vue.filter('translate', (value) => {
  return !value ? '' : Vue.prototype.$gettext(value.toString())
})

Vue.prototype.$showContactInfo = true

/* eslint-disable no-new */
const app = new Vue({
  template: `<main-component id="main-public" :navbarItems="navbarItems" />`,
  router,
  store,
  components: {
    MainComponent
  },
  data () {
    return {
      navbarItems: [
        {
          destination: '/home',
          text: 'Home',
          exact: true
        },
        {
          destination: '/certificates',
          text: 'Certificates list',
          exact: true
        }
      ]
    }
  }
}).$mount('#app')

if (window.Cypress) {
  window.app = app
}
